import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const specialistsImagesEl = document.querySelector('.specialists-sec__images');
if (specialistsImagesEl) {
  const images = specialistsImagesEl.querySelectorAll('.specialists-sec__image');

  const startAnimations = () => {
    images.forEach((img, index) => {
      const isFirst = index === 0;
      const floatY = 15;

      const landY = isFirst ? floatY : -floatY;
      const bounceY = isFirst ? -floatY : floatY;

      const tl = gsap.timeline();

      tl.fromTo(img,
        {
          opacity: 0,
          filter: 'blur(20px)',
          y: isFirst ? '-15%' : '15%',
          rotation: isFirst ? -10 : 10,
        },
        {
          opacity: 1,
          filter: 'blur(0px)',
          y: landY,
          rotation: 0,
          duration: 3.5,
          ease: 'power2.out',
          delay: 0.1
        }
      );

      tl.to(img, {
        y: bounceY,
        duration: 2.6,
        ease: 'sine.inOut',
        repeat: -1,
        yoyo: true,
      });
    });
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        startAnimations();
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1
  });

  observer.observe(specialistsImagesEl);
}